// Security update: HTML rendered from stored content is sanitized with sanitizeHtml() before it is inserted into the page.
/* ProductFAQ - Displays product-specific frequently asked questions as a compact accordion. */

import { sanitizeHtml } from '@/lib/sanitize-html';
import { motion } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { useState } from 'react';

interface ProductFAQItem {
  id: string;
  question: string;
  answer: string;
  display_order: number;
}

interface ProductFAQProps {
  faqs: ProductFAQItem[];
}

export default function ProductFAQ({ faqs }: ProductFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  if (!faqs || faqs.length === 0) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      <div className="divide-y divide-[#e7e1d6] border-t border-[#e7e1d6]">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={faq.id}>
              <button
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="group flex w-full items-center justify-between py-5 text-left transition-colors duration-200"
              >
                <span className="pr-4 text-base font-semibold text-[#1e2b22] sm:text-lg">{faq.question}</span>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-[#1e2b22] transition-colors group-hover:bg-[#e7e1d6]">
                  {isOpen ? <Minus className="h-4 w-4" strokeWidth={2.5} /> : <Plus className="h-4 w-4" strokeWidth={2.5} />}
                </span>
              </button>
              {isOpen && (
                <div className="pb-5">
                  <p className="text-base leading-7 text-[#5a6552]" dangerouslySetInnerHTML={{ __html: sanitizeHtml(faq.answer) }} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}
